module.exports = __webpack_public_path__ + "img/classic_season20_4.2b7362bf.jpg";